import React, { useContext } from "react";

import Modal from "./Index";
import { OptionButton } from "./Buttons";
import { Context } from "../../store";
import {
  setIndex,
  toggleQuestions,
} from "../../store/reducer";
import { RepeatButton } from "./Buttons";
import H2 from "../Typography/Headings";

const QuestionsModal = () => {
  const [{ currentItem, player }, dispatch] =
    useContext(Context);

  const onAnswerSelected = (key) => (e) => {
    e.preventDefault();

    dispatch(setIndex(currentItem[key]));
    dispatch(toggleQuestions());
  };

  const onRepeat = () => {
    dispatch(toggleQuestions());

    player.currentTime = 0;
    player.play();
  };

  return (
    <div className="stack max-w-3xl w-full md:max-h-96 h-full overflow-y-scroll scroll-bar pt-14 md:pt-0 pb-4 px-4">
      <H2 text={currentItem.title} />
      {Object.entries(currentItem.questions).map(
        ([key, value], index) => (
          <OptionButton
            key={key}
            text={value}
            onClick={onAnswerSelected(key)}
            index={index}
          />
        )
      )}
      <div className="flex justify-center">
        <RepeatButton onClick={onRepeat} />
      </div>
    </div>
  );
};

export default Modal(QuestionsModal);
